import React from 'react'
import { SectionHeaderWithSeeAll } from 'shared/components/section-header'
import VideoScrollCarousel from 'shared/components/video-preview-thumbnail/scroll-carousel/trending'
import styled from 'styled-components'

const Container = styled.div`
    margin-bottom: 20px;
`

const TodaysVideos = () => {
    return (
        <Container>
            <SectionHeaderWithSeeAll label="Today's Videos" url="/videos" isHistoryPush />
            <VideoScrollCarousel width={160} previewLabelPadding={6} />
        </Container>
    )
}

export default TodaysVideos
